import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { TeamsData } from '../../../assets/media';
import { enrichTeamMember } from '../../models/teamsMeta';
import { routes, teamMemberHref } from '../../models/content';

/** Redirects legacy `/teams/member?category=&index=` URLs to slug-based detail pages. */
export default function LegacyTeamMemberRedirect() {
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category');
  const index = parseInt(searchParams.get('index'), 10);
  const list = category ? TeamsData[category] : null;

  if (list && Number.isInteger(index) && index >= 0 && index < list.length) {
    const slug = enrichTeamMember(list[index]).slug;
    return <Navigate to={teamMemberHref(slug, category)} replace />;
  }

  return <Navigate to={routes.teams} replace />;
}
